import React from 'react';
import { UsersStatsSection as UsersStatsSectionImpl } from './stats.sections';

export default function UsersStatsSection(props) {
    return <UsersStatsSectionImpl {...props} />;
}
